(function () {
  'use strict';

  /* @ngdoc object
   * @name dades.llicenciaFormulari
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main.llicencies.formulari', [
      'ui.router'
    ]);
}());
